import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import Header from "./header";
import Footer from "./footer";
import moment from "moment";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { listevent } from "../service/dashboard";

const EventsList = () => {
    const [events, setEvents] = useState([]);
    const [selectedEvents, setSelectedEvents] = useState([]);
    const [date, setDate] = useState(new Date());
    const navigate = useNavigate();

    useEffect(() => {
        const temp = new FormData();

        listevent(temp).then((res) => {
            if (res.status === true) {
                setEvents(res.data.details);
            }
        });
    }, []);

    // Handle date click
    const handleDateChange = (value) => {
        setDate(value);

        const selected = events.filter((event) =>
            moment(value).isSame(event.event_start, "day")
        );

        setSelectedEvents(selected);
    };

    // Show dot on calendar days with events
    const renderTileContent = ({ date, view }) => {
        if (view === "month") {
            const dayEvents = events.filter((event) =>
                moment(date).isSame(event.event_start, "day")
            );

            if (dayEvents.length > 0) {
                return (
                    <div style={{ color: "red", fontSize: "10px",borderRadius:"50%",background:"#ffcccc",width:"20px",height:"20px",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto" }}>
                        ● {dayEvents.length}
                    </div>
                );
            }
        }
        return null;
    };

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <div className="moreheading">
                    <Row className="row-sm">
                        <Col xs={2} className="text-left align-self-end">
                            <h4 className="morehead-text">Events</h4>
                        </Col>

                        <Col xs={10} className="text-right align-self-end">
                            <Link
                                to={"/dashboard"}
                                className="btn-outline-success red-btn btn-sm"
                            >
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>
                    </Row>
                </div>

                <div className="leave-container">
                    {/* Calendar */}
                    <Calendar
                        onChange={handleDateChange}
                        value={date}
                        tileContent={renderTileContent}
                    />

                    {/* Day-wise Event List */}
                    <div className="mt-4">
                        <h5>
                            Events on {moment(date).format("DD MMM YYYY")}
                        </h5>

                        {selectedEvents.length > 0 ? (
                            selectedEvents.map((event, index) => (
                                <div
                                    key={index}
                                    className="event-card p-3 mb-3 border rounded"
                                    style={{
                                        background: "#fff",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <h6>{event.event_name}</h6>

                                    <p>
                                        <strong>Start:</strong>{" "}
                                        {moment(event.event_start).format(
                                            "DD-MM-YYYY"
                                        )}
                                    </p>

                                    <p>
                                        <strong>End:</strong>{" "}
                                        {event.event_end
                                            ? moment(event.event_end).format(
                                                  "DD-MM-YYYY"
                                              )
                                            : moment(event.event_start).format(
                                                  "DD-MM-YYYY"
                                              )}
                                    </p>

                                    <p>
                                        <strong>Location:</strong>{" "}
                                        {event.location}
                                    </p>

                                    <p>
                                        <strong>Description:</strong>{" "}
                                        {event.description}
                                    </p>

                                    {event.circular && (
                                        <p>
                                            <strong>Circular:</strong>{" "}
                                            <a
                                                href={event.path + event.circular}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                View Circular
                                            </a>
                                        </p>
                                    )}
                                </div>
                            ))
                        ) : (
                            <p style={{ color: "gray" }}>
                                No events for this day
                            </p>
                        )}
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default EventsList;